import { getUserClaims } from 'features/application/application-slice';
import { fetch_approved_media_by_id, get_media_to_watch, get_series_for_user } from 'features/auto-thunks';
import { ProcessedMedia } from 'models';
import React, { useEffect } from 'react'
import { useSelector } from 'react-redux';
import { useNavigate, useParams } from 'react-router-dom'
import { dispatch } from 'store'
export default function ApprovedMediaListItemLoaderComponent({
    onProcessedMedia
}: { onProcessedMedia: (processedMedia: ProcessedMedia) => void }) {
    const params = useParams()
    const claims = useSelector(getUserClaims);
    useEffect(() => {
        if (params?.approvedMediaId && claims?.user) {
            dispatch(fetch_approved_media_by_id({
                approvedMediaId: params?.approvedMediaId,
                userId: claims?.user,
                callback: (a, b) => {
                    if (b && b.data.length) {
                        onProcessedMedia(b.data[0].processedMedia);
                    }
                }
            }))
        }
        if (params?.id !== 'inde' && claims?.user) {
            dispatch(get_series_for_user({
                approvedSeriesId: params?.id,
                userId: claims?.user
            }));
        }
    }, [params?.approvedMediaId, claims?.user, params?.id]);
    useEffect(() => {
        if (claims?.user && params?.id) {
            dispatch(
                get_media_to_watch({
                    fireid: claims?.fire_user,
                    id: params?.id,
                    approvedMediaId: params?.approvedMediaId,
                    subid: params?.media
                })
            )
        }
    }, [claims?.user, params?.id, params?.media, params?.approvedMediaId])
    return <></>
}